import React from 'react';
import PWAInstallPrompt from './PWAInstallPrompt';

const layoutStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;900&family=Pacifico&display=swap');
    body { font-family: 'Inter', sans-serif; background: #fff1f2; margin: 0; }
    .glass-premium { 
        background: rgba(255, 255, 255, 0.85); 
        backdrop-filter: blur(20px); 
        -webkit-backdrop-filter: blur(20px); 
        border: 1px solid rgba(219, 39, 119, 0.2); 
        box-shadow: 0 40px 60px -15px rgba(0, 0, 0, 0.05); 
    }
    .form-control-premium {
        background: white !important;
        border: 1px solid rgba(219, 39, 119, 0.2) !important;
        border-radius: 15px !important;
        padding: 12px 18px !important;
        transition: all 0.3s ease;
    }
    .form-control-premium:focus {
        border-color: #db2777 !important;
        box-shadow: 0 0 0 4px rgba(219, 39, 119, 0.1) !important;
    }
    .blob { position: fixed; width: 600px; height: 600px; border-radius: 50%; z-index: -1; animation: float 30s infinite alternate; }
    .blob-1 { background: radial-gradient(circle, rgba(251,113,133,0.2) 0%, rgba(255,255,255,0) 70%); top: -10%; left: -10%; }
    .blob-2 { background: radial-gradient(circle, rgba(245,158,11,0.15) 0%, rgba(255,255,255,0) 70%); bottom: -10%; right: -10%; animation-delay: -5s; }
    @keyframes float { 0% { transform: translate(0,0) rotate(0deg); } 100% { transform: translate(100px, 100px) rotate(15deg); } }
    .ls-lg { letter-spacing: 0.15em; }
    .fw-900 { font-weight: 900; }
    .magic-heart { font-family: 'Inter', sans-serif; font-weight: 900; letter-spacing: -0.02em; color: #db2777; text-transform: uppercase; }
    .fade-in-up { animation: fadeInUp 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards; opacity: 0; }
    @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
    .text-pink-600 { color: #db2777 !important; }
`;

export const Branding = () => (
    <div className="mb-4 text-center">
        <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
            <i className="fas fa-heart fa-4x" style={{ color: '#db2777' }}></i>
        </div>
        <h1 className="fw-900 mb-0 magic-heart" style={{ fontSize: '2.2rem' }}>SOLTEROS</h1>
        <p className="text-muted small fw-600 ls-lg text-uppercase mb-0">Speed Date Pro</p>
    </div>
);

export const Copyright = () => (
    <div className="mt-5 pt-4 border-top border-light opacity-50 text-center">
        <p className="small mb-0 fw-600 ls-lg text-muted">COPYRIGHT 2026 WWW.SOLTEROS.IT</p>
    </div>
);

const Layout = ({ children, unreadCount, onBellClick }) => {
    return (
        <div className="container min-vh-100 d-flex flex-column py-4 py-md-5 px-3 position-relative overflow-x-hidden">
            <style>{layoutStyles}</style>
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>
            
            {onBellClick && unreadCount > 0 && (
                <div 
                    className="position-fixed top-0 end-0 p-3" 
                    style={{ zIndex: 1050 }}
                >
                    <button 
                        onClick={onBellClick}
                        className="btn btn-light rounded-circle shadow-lg d-flex align-items-center justify-content-center position-relative transition-all hover-scale"
                        style={{ width: '45px', height: '45px', border: '1px solid rgba(219, 39, 119, 0.2)' }}
                    >
                        <i className="fas fa-bell text-pink-600 fs-5"></i>
                        {unreadCount > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger shadow-sm border border-white" style={{ fontSize: '0.6rem' }}>
                                {unreadCount}
                            </span>
                        )}
                    </button>
                </div>
            )}

            {children}
            <PWAInstallPrompt />
        </div>
    );
};

export default Layout;
